import type { CSSProperties } from "react";

export interface PlayerTheme {
  color: string;
  soft: string;
  ink: string;
  name: string;
  piece: string;
}

export interface PlayerThemeStyle extends CSSProperties {
  "--player-color": string;
  "--player-soft": string;
  "--player-ink": string;
}

const PLAYER_THEMES: readonly PlayerTheme[] = [
  { color: "#f05f78", soft: "rgba(240, 95, 120, .22)", ink: "#21070d", name: "绯樱", piece: "♟" },
  { color: "#62aef7", soft: "rgba(98, 174, 247, .22)", ink: "#061523", name: "苍天", piece: "♟" },
  { color: "#68cf91", soft: "rgba(104, 207, 145, .22)", ink: "#071a0e", name: "若竹", piece: "♟" },
  { color: "#f2b85b", soft: "rgba(242, 184, 91, .22)", ink: "#201305", name: "琥珀", piece: "♟" },
  { color: "#ae87ec", soft: "rgba(174, 135, 236, .22)", ink: "#140922", name: "藤紫", piece: "♟" },
  { color: "#46cfca", soft: "rgba(70, 207, 202, .22)", ink: "#061a19", name: "浅葱", piece: "♟" },
  { color: "#f08b55", soft: "rgba(240, 139, 85, .22)", ink: "#211006", name: "柿色", piece: "♟" },
  { color: "#d2d967", soft: "rgba(210, 217, 103, .22)", ink: "#191b06", name: "萌黄", piece: "♟" },
];

const CAMP_ACCENTS: Record<string, string> = {
  boss: "#d45f68",
  jiki: "#63a9dc",
  yajiuma: "#72b77d",
};

const CARD_ACCENTS: Record<string, string> = {
  hakurei: "#d96b79",
  moriya: "#72b77d",
  kleinji: "#68a3d2",
};

export function campAccent(camp: string | null | undefined): string {
  return (camp && CAMP_ACCENTS[camp]) || "#c9a65a";
}

export function cardAccent(id: string | null | undefined): string {
  if (!id) return "#c9a65a";
  const family = id.split("_", 1)[0] ?? "";
  return CARD_ACCENTS[family] ?? "#c9a65a";
}

export function placeAccent(place: string | null | undefined): string {
  if (place === "hakurei" || place === "eientei") return CARD_ACCENTS.hakurei!;
  if (place === "moriya" || place === "magic_forest") return CARD_ACCENTS.moriya!;
  return CARD_ACCENTS.kleinji!;
}

export function playerTheme(index: number): PlayerTheme {
  return PLAYER_THEMES[((index % PLAYER_THEMES.length) + PLAYER_THEMES.length) % PLAYER_THEMES.length]!;
}

export function playerThemeStyle(index: number): PlayerThemeStyle {
  const theme = playerTheme(index);
  return {
    "--player-color": theme.color,
    "--player-soft": theme.soft,
    "--player-ink": theme.ink,
  };
}
